import { InfoOutlineIcon,} from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledInfoIcon = styled(InfoOutlineIcon)`
  &:hover {
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
`;
